var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.365 29.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#702180;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image_Generator",
    "data-name": "Image Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.683,
    cy: 14.683,
    r: 14.683
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.791,19.965V18.792a1.76,1.76,0,0,0-1.76-1.761h-4.7a1.76,1.76,0,0,0-1.761,1.761v1.173a.587.587,0,1,1-1.174,0V18.792a2.934,2.934,0,0,1,2.935-2.935h4.7a2.934,2.934,0,0,1,2.934,2.935v1.173a.587.587,0,1,1-1.174,0Zm-7.043-8.217a2.935,2.935,0,1,1,2.935,2.935A2.935,2.935,0,0,1,11.748,11.748Zm1.174,0a1.761,1.761,0,1,0,1.761-1.761A1.761,1.761,0,0,0,12.922,11.748Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c21abea9c266b10378fadf1a9e5d6e43.svg";
export { ForwardRef as ReactComponent };